import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { BaseHttpService } from '@shared/services/base-http.service';
import { map } from 'rxjs/operators';
import { Response } from '@shared/models/response.model';
import { User } from '@shared/models/user/user.model';
import { Observable } from 'rxjs';
import { Social } from '@shared/interfaces/account/social.interface';
import { Language } from '@shared/interfaces/account/language.interface';
import { Countries } from '@shared/interfaces/account/countries.interface';
import { Cacheable } from 'ts-cacheable';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  constructor(public http: HttpClient, public router: Router, public baseHttp: BaseHttpService) {}

  deleteAccount(pack): Observable<Response<User>> {
    return this.baseHttp.post('/user-delete', pack).pipe(map((resp) => resp as Response<User>));
  }

  @Cacheable({
    maxAge: 600,
  })
  countriesList(): Observable<Response<Countries[]>> {
    return this.baseHttp
      .get('/noauth/parameters/countries')
      .pipe(map((resp) => resp as Response<Countries[]>));
  }

  @Cacheable({
    maxAge: 600,
  })
  allCountriesList(): Observable<Response<Countries[]>> {
    return this.baseHttp
      .get('/noauth/parameters/all-countries')
      .pipe(map((resp) => resp as Response<Countries[]>));
  }

  @Cacheable({
    maxAge: 600,
  })
  socialList(): Observable<Response<Social[]>> {
    return this.baseHttp
      .get('/noauth/parameters/social')
      .pipe(map((resp) => resp as Response<Social[]>));
  }

  @Cacheable({
    maxAge: 600,
  })
  languageList(): Observable<Response<Language[]>> {
    return this.baseHttp
      .get('/noauth/parameters/languages')
      .pipe(map((resp) => resp as Response<Language[]>));
  }

  getUserInfo(): Observable<Response<User>> {
    return this.baseHttp.get('/user').pipe(map((resp) => resp as Response<User>));
  }

  changeUser(pack, id): Observable<Response<User>> {
    return this.baseHttp
      .post('/users/' + id, { user: pack })
      .pipe(map((resp) => resp as Response<User>));
  }

  changeLang(pack): Observable<Response<Language[]>> {
    return this.baseHttp
      .post('/user/language', pack)
      .pipe(map((resp) => resp as Response<Language[]>));
  }

  resendVerEmail(): Observable<Response<any>> {
    return this.baseHttp.get('/resend-confirm-email').pipe(map((resp) => resp as Response<any>));
  }
}
